import { 
    TOGGLE_HEATBLOCK_MODAL_HB,
    UPDATE_TEMPERATURE_HB, 
    TUBE_DROP_HB, 
    CHECK_BALANCE_HB, 
    TEMPREATURE_BALANCE_HB, 
    TOOLTIP_DISPLAY_HB, 
    TOOLTIP_REMOVE_HB, 
    TUBE_TOOLTIP_DISPLAY_HB, 
    TUBE_TOOLTIP_REMOVE_HB, 
    REMOVE_TUBE_FROM_HEATBLOCK_HB, 
    SET_HEATING_HB, 
 } from "../Redux.constants";

//Creates new heatblock and adds to array of heatblocks
export const createHeatBlock = (data) => {
    //data = {id, solution}
    return { type: "CREATE_HEAT_BLOCK", payload: data }
}

// ---Heat Block ----------------------------:
export const toggleModalHB = (payload) => {
    return { type: TOGGLE_HEATBLOCK_MODAL_HB, payload }
}

export const tooltipDisplayHB = (payload) => {
    return { type: TOOLTIP_DISPLAY_HB, payload }
}

export const tooltipRemoveHB = (payload) => {
    return { type: TOOLTIP_REMOVE_HB, payload }
}

export const setTemperatureHB = (params) => {
    return { type: UPDATE_TEMPERATURE_HB, payload: params }
}

export const onTubeDropHB = (params) => {
    return { type: TUBE_DROP_HB, payload: params }
}

export const checkBalanceHB = (payload) => {
    return { type: CHECK_BALANCE_HB, payload }
}

export const temperatureBalanceHB = (payload) => {
    return { type: TEMPREATURE_BALANCE_HB, payload }
}


export const tubeTooltipDisplayHB = (payload) => {
    return { type: TUBE_TOOLTIP_DISPLAY_HB, payload }
}

export const tubeTooltipRemoveHB = (payload) => {
    return { type: TUBE_TOOLTIP_REMOVE_HB, payload }
}

export const removeTubeFromHeatblockHB = (payload) => {
    return { type: REMOVE_TUBE_FROM_HEATBLOCK_HB, payload }
}

export const addTubeToHeatBlock = (data) => {
    //data = {cathodeConnected}
    return { type: "ADD_TUBE_TO_HEAT_BLOCK", payload: data}
}
export const removeTubeFromHeatBlock = (data) => {
    //data = {cathodeConnected}
    return { type: "REMOVE_TUBE_FROM_HEAT_BLOCK", payload: data}
}